/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function ArrowDropDownIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path id="Vector" d="M8 0.5H2C0.9 0.5 0.00999999 1.4 0.00999999 2.5L0 14.5C0 15.6 0.9 16.5 2 16.5H18C19.1 16.5 20 15.6 20 14.5V4.5C20 3.4 19.1 2.5 18 2.5H10L8 0.5Z" fill="currentColor"/>
    </SvgIcon>
  );
}
